"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ palette, spacing, typography }) => ({
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: 'auto',
        height: 'auto',
        marginBottom: 4,
        marginRight: spacing(1),
        color: palette.icon.secondary,
    },
    panel: {
        backgroundColor: palette.surface.default,
        border: `1px solid ${palette.divider}`,
        padding: spacing(3),
    },
    sectionTitle: {
        marginBottom: spacing(2),
    },
    toggleGroup: {
        gap: spacing(2),
        '& .MuiToggleButtonGroup-grouped': {
            border: 'unset !important',
            borderRadius: '6px !important',
        },
    },
    toggleButton: {
        backgroundColor: palette.surface.subtle,
        borderRadius: '6px !important',
        color: palette.text.primary,
        gap: spacing(1),
        padding: spacing(0.75, 2),
        textTransform: 'none',
        cursor: 'pointer !important',
        '&:hover': {
            backgroundColor: palette.surface.subtle,
        },
        '&.Mui-selected': {
            backgroundColor: palette.action.surface,
            color: palette.primary.contrastText,
            '&:hover': {
                backgroundColor: palette.action.surface,
            },
        },
    },
});
exports.default = styles;
